import { darkClassicTheme, lightClassicTheme, lightModernTheme } from '../styles';
import { Theme } from '../types';
export function getThemeData(theme) {
    switch (theme) {
        case Theme.LIGHT_CLASSIC: {
            return lightClassicTheme;
        }
        case Theme.DARK_CLASSIC: {
            return darkClassicTheme;
        }
        case Theme.LIGHT_MODERN: {
            return lightModernTheme;
        }
        default:
            // TODO: return default MUI theme
            return lightModernTheme;
    }
}
